<template>
  <div>
    <edit-load-order :data="details"  @submit="getDetails()"/>
    <vs-row id="load-order-details-loading" class="vs-con-loading__container">
      <vs-col vs-w="12" class="px-2">
        <vs-card>
          <div slot="header" class="display-flex">
            <vs-row>
              <vs-col vs-w="10" vs-type="flex">
                <feather-icon icon="PackageIcon" class="mx-1 icon-title" />
                <h4>{{ details.no_order || '' }}</h4>
              </vs-col>
              <vs-col
                vs-w="2"
                vs-type="flex"
                vs-justify="flex-end"
                vs-align="center"
              >
                <action-icon icon="PlusCircleIcon" @click="$router.push('/load_orders/create/'+loadOrderId)" :tooltip="$t('add')" v-if="details.status == '2'"/>
                <action-icon
                  icon="EditIcon"
                  :tooltip="$t('edit')"
                  @click="openEdit"
                  v-if="details.status !== '4'"
                />
              </vs-col>
            </vs-row>
          </div>
          <load-order-details :loadOrder="details" :signData="signData"  />
        </vs-card>
      </vs-col>
      <vs-col vs-w="12" class="px-2">
        <vs-card>
          <vs-tabs>
            <vs-tab
              :label="$t('files') | capitalize"
              icon-pack="feather"
              icon="icon-image"
            >
              <div class="tab-text">
                <file-list :data="files" />
              </div>
            </vs-tab>
            <vs-tab
              :label="$t('review_orders') | capitalize"
              icon-pack="feather"
              icon="icon-file"
            >
              <div class="tab-text">
                <review-order-list :reviewOrders="reviewOrders" />
              </div>
            </vs-tab>
          </vs-tabs>
        </vs-card>
      </vs-col>
      <vs-col vs-w="12" class="px-2">
        <vs-card>
          <div slot="header" class="display-flex">
            <vs-row>
              <vs-col vs-w="12" vs-type="flex">
                <feather-icon icon="ClockIcon" class="mx-1 icon-title" />
                <h4 class="mt-1">{{ $t('timeline') | capitalize }}</h4>
              </vs-col>
            </vs-row>
          </div>
          <timeline :data="timeline" />
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import Timeline from '@/views/components/Timeline'
import FileList from '@/views/components/FileList.vue'
import loadOrder from '@/http/requests/loadOrder'
import LoadOrderDetails from './components/LoadOrderDetails.vue'
import ReviewOrderList from './components/ReviewOrderList.vue'
import EditLoadOrder from './components/EditLoadOrder.vue'
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import loading from '@/mixins/Loading'
export default {
  components: {
    LoadOrderDetails,
    EditLoadOrder,
    ReviewOrderList,
    Timeline,
    FileList,
    ActionIcon,
  },
  computed: {
    loadOrderId() {
      return this.$route.params.id
    },
    isLoading() {
      return this.loading.details 
      || this.loading.files 
      || this.loading.invoices 
      || this.loading.timeline 
      || this.loading.reviewOrders
      || this.loading.sign
    },
  },
  data() {
    return {
      details: {},
      files: [],
      invoices: [],
      timeline: [],
      reviewOrders: [],
      signData:{
        byProxy: 1,
        file: {},
        overtime: '0',
        pallets: 0
      },
      loading:{
        details:false,
        files:false,
        timeline:false,
        reviewOrders:false,
        sign:false
      }
    }
  },
  mixins: [loading],
  methods: {
    getDetails() {
      this.loading.details = true
      loadOrder
        .getDetails(this.loadOrderId)
        .then(res => {
          this.details = res.data.item
          this.loading.details = false
        })
        .catch( res => {
          this.loading.details = false
        })
    },
    getFiles() {
      this.loading.files = true
      loadOrder
        .getFiles(this.loadOrderId)
        .then( res  => {
          this.loading.files = false
          this.files = res.data.items
        })
        .catch( res => {
          this.loading.files = false
        })
    },
    getSign() {
      this.loading.sign = true
      loadOrder
        .getSign(this.loadOrderId)
        .then( response  => {
          this.loading.sign = false
          this.signData = { ...response.data.data.body}
          if(response.data.data.file !== undefined){
             this.signData.file = response.data.data.file
          }
        })
        .catch( response => {
          this.loading.sign = false
        })
    },
    getReviewOrders() {
      this.loading.reviewOrders = true
      loadOrder
        .getReviewOrders(this.loadOrderId)
        .then( res => {
          this.loading.reviewOrders = false
          this.reviewOrders = res.data.items
        })
        .catch( res => {
          this.loading.reviewOrders = false
        })
    },
    // getInvoices() {
    //   this.loading.invoices = true
    //   loadOrder
    //     .getInvoices(this.loadOrderId)
    //     .then( res => {
    //       this.loading.invoices = false
    //       this.invoices = res.data.items
    //       console.log(this.res.data.items);
    //     })
    //     .catch( res => {
    //       this.loading.invoices = false
    //     })
    // },
    getTimeline() {
      this.loading.timeline = true
      loadOrder
        .getTimeline(this.loadOrderId)
        .then(res => {
          this.loading.timeline = false
          this.timeline = res.data.data
        })
        .catch( res => {
          this.loading.timeline = false
        })
    },
    openEdit() {
      this.$store.dispatch('toggleSidebar', 'edit-load-order')
    },
  },

  mounted() {
    this.getDetails()
    this.getTimeline()
    this.getFiles()
    this.getReviewOrders()
    this.getSign()
  },

  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('load-order-details-loading')
      } else {
        this.closeLoading('load-order-details-loading')
      }
    },
  },
}
</script>

<style></style>
